import { Shield, Lock, Key, FileCheck, Webhook, Database, Server, Eye, EyeOff, Globe } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card.js";

export default function SeguridadPage() {
  const controls = [
    {
      icon: Key,
      title: "Cifrado de credenciales",
      description: "Las credenciales del SII se cifran con AES-256-GCM usando una clave maestra (ENCRYPTION_KEY). Las claves nunca se persisten en texto plano en la base de datos.",
    },
    {
      icon: Database,
      title: "Row Level Security (RLS)",
      description: "PostgreSQL RLS asegura que cada usuario solo puede acceder a sus propios contribuyentes y documentos. El aislamiento se aplica a nivel de base de datos, independiente del código de la aplicación.",
    },
    {
      icon: Lock,
      title: "Idempotency-Key",
      description: "Todas las operaciones de escritura (emisión, anulación, confirmación) soportan el header Idempotency-Key para prevenir duplicados. Si reenvías una request con el mismo key, recibes la misma respuesta original.",
    },
    {
      icon: FileCheck,
      title: "Cálculo server-side",
      description: "Los montos neto, IVA y total se calculan en el servidor. El cliente nunca define estos valores — solo envía los items y el servidor calcula, valida y persiste.",
    },
    {
      icon: Server,
      title: "Emisión asíncrona (202)",
      description: "Las emisiones se procesan en cola (background worker). La API responde 202 inmediatamente y el frontend hace polling del estado. Esto evita timeouts y mejora la resiliencia.",
    },
    {
      icon: Webhook,
      title: "Webhooks firmados",
      description: "Cuando un documento cambia de estado, se despacha un webhook con firma HMAC-SHA256. Incluye retry con backoff exponencial (hasta 5 intentos).",
    },
    {
      icon: Eye,
      title: "Audit Log",
      description: "Toda operación sensible (emisión, anulación) se registra en SiiAuditLog con IP, User-Agent y timestamp. Trazabilidad completa.",
    },
    {
      icon: EyeOff,
      title: "Credenciales efímeras",
      description: "La clave del SII se recibe por request, se usa en memoria para el scraping, y se descarta. Nunca se persiste en la base de datos.",
    },
    {
      icon: Globe,
      title: "CORS y rate limiting",
      description: "En producción, el acceso está restringido a app.foliolisto.cl vía CORS. El login está limitado a 5 intentos por minuto por IP. La documentación Swagger solo está disponible en desarrollo.",
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Shield className="h-8 w-8 text-primary" />
        <div>
          <h2 className="text-2xl font-bold">Seguridad</h2>
          <p className="text-muted-foreground">Controles de seguridad implementados en FolioListo</p>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {controls.map((ctrl) => (
          <Card key={ctrl.title}>
            <CardHeader>
              <div className="flex items-center gap-2">
                <ctrl.icon className="h-5 w-5 text-primary" />
                <CardTitle className="text-base">{ctrl.title}</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm leading-relaxed">
                {ctrl.description}
              </CardDescription>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Reportar vulnerabilidad</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Si encuentras una vulnerabilidad de seguridad, repórtala a{" "}
            <a href="mailto:security@foliolisto.cl" className="text-primary underline">
              security@foliolisto.cl
            </a>
            . No divulgues públicamente vulnerabilidades no parchadas.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
